import { useState, useEffect } from "react";
import axios from "axios";
import { FaAngleDoubleDown, FaAngleDoubleUp } from "react-icons/fa";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import "swiper/swiper-bundle.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import OtpSubmit from "./../components/OtpSubmit/OtpSubmit";

// Import Lucide Icons
import { Package, ShoppingBag, Utensils } from "lucide-react";

import "./PendingOrderAccordion.css";
import ReceiptModal from "./ReceiptModal";
import QRCode from "../../../Assets/Icons/qrcode3.png";
import Receipt from "../../../Assets/Icons/rcpt5.png";
import { IoReceiptOutline } from "react-icons/io5";
import OrderStatusStepper from "../components/OrderStatusStepper/OrderStatusStepper";
import DeliveryPersonCard from "../components/DeliveryPersonCard/DeliveryPersonCard";
import DeliveryAddress from "../components/DeliveryAddress/DeliveryAddress";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import OTPDisplay from "./OtpDisplay/OTPDisplay";

const PendingOrderAccordion = (props) => {
  const [expandedOrders, setExpandedOrders] = useState([]);
  const { orders } = props;

  console.log("Pending Orders123: ", orders);

  const [orderFilters, setOrderFilters] = useState({});

  // ✅ ADDED: Function to get unique order types from subOrderStatus
  const getOrderTypes = () => {
    const types = new Set();
    orders?.forEach((order) => {
      if (order.subOrderStatus && Array.isArray(order.subOrderStatus)) {
        order.subOrderStatus.forEach((subOrder) => {
          if (subOrder.orderTypeName) {
            types.add(subOrder.orderTypeName);
          }
        });
      }
    });
    return Array.from(types);
  };

  const handleToggle = (index) => {
    setExpandedOrders((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const [open, setOpen] = useState({ isOpen: false, timeLine: [] });

  console.log("open", orders);

  const handleOpen = (data) => {
    console.log("openqw", data);
    setOpen({ isOpen: true, timeLine: data });
  };

  const handleClose = () => {
    setOpen({ isOpen: false, timeLine: [] });
  };

  const getAppropiateStatus = (restaurant) => {
    console.log("lkl", restaurant);
    let hasQueue = false;
    let hasPending = false;
    let hasReady = false;
    let hasServed = false;
    let hasPreparing = false;
    let hasRefund = false;
    let hasOnTheWayToRestaurant = false;
    let hasOnTheWayToCustomer = false;

    restaurant?.foodItems?.forEach((foodItem) => {
      if (foodItem.foodStatus === "Queue") hasQueue = true;
      if (foodItem.foodStatus === "Pending") hasPending = true;
      if (foodItem.foodStatus === "Preparing") hasPreparing = true;
      if (foodItem.foodStatus === "Ready") hasReady = true;
      if (foodItem.foodStatus === "Served") hasServed = true;
      if (foodItem.foodStatus === "Completed") hasServed = true;
      if (foodItem.foodStatus === "Canceled") hasRefund = true;
      if (foodItem.foodStatus === "Refund") hasRefund = true;
      if (foodItem.foodStatus === "On the way to Restaurant")
        hasOnTheWayToRestaurant = true;
      if (foodItem.foodStatus === "En-Route") hasOnTheWayToCustomer = true;
    });

    if (hasQueue) return "Queue";
    else if (hasPending) return "Pending";
    else if (hasReady) return "Ready";
    else if (hasServed) return "Served";
    else if (hasPreparing) return "Preparing";
    else if (hasRefund) return "Refund";
    else if (hasOnTheWayToRestaurant) return "On the way to Restaurant";
    else if (hasOnTheWayToCustomer) return "En-Route";
  };

  const getQRCode = (orderId) => {
    props.GetQRCode(orderId);
  };

  const getSubTotalOFComponentPrice = (item) => {
    const foodBaseSubtotal = (item?.basePrice || 0) * item?.foodItemQuantity;

    const addOnsSubtotal = (item?.addOns || []).reduce((addOnSum, addOn) => {
      const addOnBaseSubtotal =
        (addOn?.addOnBasePrice || 0) * addOn?.addOnQuantity;

      const addOnOptionsSubtotal = (addOn?.options || []).reduce(
        (optSum, option) => {
          const optionBaseSubtotal =
            (option?.optionBasePrice || 0) * option?.optionQuantity;

          const subOptionsSubtotal = (option?.subOptions || []).reduce(
            (subSum, subOption) => {
              return (
                subSum +
                (subOption?.subOptionBasePrice || 0) *
                  subOption?.subOptionQuantity
              );
            },
            0,
          );

          return optSum + optionBaseSubtotal + subOptionsSubtotal;
        },
        0,
      );

      return addOnSum + addOnBaseSubtotal + addOnOptionsSubtotal;
    }, 0);

    const subtotal = foodBaseSubtotal + addOnsSubtotal;
    return subtotal?.toFixed(2);
  };
  // OTP Service
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (otp, orderId) => {
    setLoading(true);
    setError("");
    const token = localStorage.getItem("gotasteClienttoken");
    const decodedToken = jwtDecode(token);

    await axios
      .post(
        `${process.env.REACT_APP_SECRET}/api/Orders/verify-delivery/${decodedToken.UserId}`,
        { otp, orderId },
      )
      .then((res) => {
        if (res.data === "OTP verified successfully") {
          toast.success(res.data || "Delivery verified successfully!");
        } else {
          toast.error(res.data || "Delivery verification failed!");
        }

        setOpenOtpModal(false);
      })
      .catch((err) => {
        setError(
          err.response?.data?.message ||
            "Verification failed. Please try again.",
        );
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      <h2 className="text-center">Order Details</h2>
      <p className="text-center text-muted">{orders?.length} Orders pending</p>
      <div className="pending-container mt-4">
        {orders
          ?.sort(
            (b, a) => new Date(a?.orderDateTime) - new Date(b?.orderDateTime),
          )
          ?.map((order, index) => {
            const isExpanded = expandedOrders.includes(index);

            const filteredFoods = (order.foodItems || []).filter(
              (item) => item.foodItemQuantity > 0,
            );
            const filteredRefunds = (order.refundDetails || []).filter(
              (r) => r.foodItemQuantity > 0,
            );
            const allItems = [
              ...filteredFoods.map((item) => ({ ...item, type: "food" })),
              ...filteredRefunds.map((item) => ({ ...item, type: "refund" })),
            ];
            const totalCount = allItems.length;
            const displayedItems = isExpanded ? allItems : allItems.slice(0, 3);

            const activeOrderType =
              orderFilters[order.orderId] ||
              (Array.isArray(order.subOrderStatus) &&
                order.subOrderStatus[0]?.orderTypeName) ||
              "Delivery";

            return (
              <Accordion key={index} defaultExpanded={index === 0}>
                <AccordionSummary className="shadow">
                  <div className="d-flex justify-content-between align-items-center w-100 pending-order-accordion-header">
                    <div className="mb-3 d-flex align-items-center">
                      {/* Restaurant Logo on the Left */}
                      <div className="pending-restaurant-logo me-3">
                        <img src={order.restaurantLogo} alt="logo" />
                      </div>

                      {/* Order Details on the Right */}
                      <div
                        style={{
                          color: "#371B17",
                          fontSize: "15px",
                          fontWeight: "500",
                        }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "20px" }}
                        >
                          <span
                            style={{
                              color: "#371B17",
                              fontSize: "15px",
                              fontWeight: "500",
                            }}
                          >
                            Order Id: {order.orderId.slice(-6)}
                          </span>
                          <strong
                            style={{
                              color: "#371B17",
                              fontSize: "10.5px",
                              fontWeight: "400",
                            }}
                          >
                            {new Date(order.orderDateTime).toLocaleString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              },
                            )}
                          </strong>
                        </div>
                        <strong style={{ fontWeight: "650" }}>
                          {order.restaurantName}
                        </strong>{" "}
                        <br />
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      {props.GetQRCode && (
                        <div
                          className="receipt-button"
                          style={{ marginRight: "10px" }}
                        >
                          <img
                            src={QRCode}
                            alt="QR Icon"
                            onClick={() => {
                              getQRCode(order.orderId);
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      )}

                      <button
                        className="receipt-button "
                        // onClick={() => handleOpen(order.timeLine)}
                      >
                        <IoReceiptOutline size={30} color="black" />
                      </button>

                      {Array.isArray(order.timeLine) &&
                        order.timeLine.length > 0 && (
                          <button
                            className="receipt-button"
                            onClick={() => {
                              const mapped = order.timeLine.map((item) => ({
                                status: item.status,
                                itemName: item.itemName,
                                amount: item.amount,
                                dateTime: item.dateTime,
                              }));

                              handleOpen(mapped);
                            }}
                          >
                            <img src={Receipt} alt="Receipt Icon" />
                          </button>
                        )}

                      {/* <button
                        className="status-badge px-3 py-1 me-3"
                        style={{
                          background:
                            getAppropiateStatus(order) === "Pending"
                              ? "rgba(243, 156, 18, .2)"
                              : getAppropiateStatus(order) === "Queue"
                                ? "rgba(239, 83, 80, .2)"
                                : getAppropiateStatus(order) === "Preparing"
                                  ? "rgba(41, 128, 185, .2)"
                                  : getAppropiateStatus(order) === "Ready"
                                    ? "rgba(39, 174, 96, .2)"
                                    : getAppropiateStatus(order) === "Refund"
                                      ? "rgba(192, 57, 43, .2)"
                                      : "",
                          color:
                            getAppropiateStatus(order) === "Pending"
                              ? "rgb(243, 156, 18)"
                              : getAppropiateStatus(order) === "Queue"
                                ? "rgb(239, 83, 80)"
                                : getAppropiateStatus(order) === "Preparing"
                                  ? "rgb(41, 128, 185)"
                                  : getAppropiateStatus(order) === "Ready"
                                    ? "rgb(39, 174, 96)"
                                    : getAppropiateStatus(order) === "Refund"
                                      ? "rgb(192, 57, 43)"
                                      : "",
                          border: "none",
                          borderRadius: "20px",
                        }}
                      >
                        {getAppropiateStatus(order)}
                      </button> */}

                      {(() => {
                        const status = getAppropiateStatus(order);

                        return (
                          <div
                            style={{
                              background:
                                status === "Pending"
                                  ? "rgba(243, 156, 18, .2)"
                                  : status === "Queue"
                                    ? "rgba(239, 83, 80, .2)"
                                    : status === "Preparing"
                                      ? "rgba(41, 128, 185, .2)"
                                      : status === "Ready"
                                        ? "rgba(39, 174, 96, .2)"
                                        : status === "Refund"
                                          ? "rgba(192, 57, 43, .2)"
                                          : status ===
                                              "On the way to Restaurant"
                                            ? "rgba(155, 89, 182, .2)" // 🔵 Purple tone
                                            : status === "En-Route"
                                              ? "rgba(52, 152, 219, .2)" // 🔵 Light blue tone
                                              : "",

                              color:
                                status === "Pending"
                                  ? "rgb(243, 156, 18)"
                                  : status === "Queue"
                                    ? "rgb(239, 83, 80)"
                                    : status === "Preparing"
                                      ? "rgb(41, 128, 185)"
                                      : status === "Ready"
                                        ? "rgb(39, 174, 96)"
                                        : status === "Refund"
                                          ? "rgb(192, 57, 43)"
                                          : status ===
                                              "On the way to Restaurant"
                                            ? "rgb(155, 89, 182)"
                                            : status === "En-Route"
                                              ? "rgb(52, 152, 219)"
                                              : "",

                              border: "none",
                              borderRadius: "20px",
                              padding: "6px 14px",
                              fontWeight: 600,
                            }}
                          >
                            {status}
                          </div>
                        );
                      })()}
                      <p
                        style={{ marginLeft: "1em" }}
                        className="text-color mb-0 price-tag"
                      >
                        £{order.total}
                      </p>
                    </div>
                  </div>
                </AccordionSummary>

                <AccordionDetails className="bg-light mt-2">
                  <div className="order-images mb-3">
                    <Swiper
                      spaceBetween={0}
                      slidesPerView={2.4}
                      onSlideChange={() => console.log("slide change")}
                      onSwiper={(swiper) => console.log(swiper)}
                      navigation={true}
                      breakpoints={{
                        437: {
                          slidesPerView: order?.images?.length > 1 ? 2 : 1,
                          spaceBetween: 5,
                        },
                        545: {
                          spaceBetween: 12,
                          slidesPerView: 2.4,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                      }}
                    >
                      {order?.images?.map((image, idx) => (
                        <SwiperSlide key={idx} className="d-flex">
                          <div className="pending-slider-img-container">
                            <img
                              src={image.url}
                              alt={`${order.orderId}-${idx}`}
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  {/* ✅ Conditional Filter: only show if >1 subOrder */}
                  {order.subOrderStatus?.length > 1 && (
                    <div className="d-flex justify-content-start mb-3">
                      {/* Replace select with button group */}
                      <div className="order-type-buttons d-flex gap-2">
                        {order.subOrderStatus.map((subOrder, idx) => {
                          const isActive =
                            orderFilters[order.orderId] ===
                            subOrder.orderTypeName;
                          // Determine icon based on order type
                          let IconComponent = Package; // Default icon
                          if (
                            subOrder.orderTypeName === "Self-Collection" ||
                            subOrder.orderTypeName === "Collection"
                          ) {
                            IconComponent = ShoppingBag;
                          } else if (
                            subOrder.orderTypeName === "In-Store" ||
                            subOrder.orderTypeName === "Dine-In"
                          ) {
                            IconComponent = Utensils;
                          }

                          return (
                            <button
                              key={`${subOrder.orderTypeName}-${idx}`}
                              className={`order-type-btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill ${
                                isActive ? "active" : ""
                              }`}
                              onClick={() =>
                                setOrderFilters((prev) => ({
                                  ...prev,
                                  [order.orderId]: subOrder.orderTypeName,
                                }))
                              }
                              style={{
                                backgroundColor: isActive
                                  ? "#371B17"
                                  : "#f8f9fa", // Brand color for active, light gray for inactive
                                color: isActive ? "white" : "#371B17",
                                border: `1px solid ${
                                  isActive ? "#371B17" : "#dee2e6"
                                }`,
                                fontWeight: isActive ? "bold" : "normal",
                                transition: "all 0.2s ease",
                              }}
                            >
                              <IconComponent size={16} />
                              {subOrder.orderTypeName === "Self-Collection"
                                ? "Collection"
                                : subOrder.orderTypeName === "In-Store"
                                  ? "Dine-In"
                                  : subOrder.orderTypeName}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* <ProgressBar order={order} /> */}
                  {/* <OrderStatusStepper currentStep={4} /> */}
                  {/* ✅ DYNAMIC Stepper Type & Step Logic */}

                  {(() => {
                    // Determine active filter
                    // ✅ Auto-fallback: use selected filter, or first subOrder if none selected / only one exists
                    const activeFilter =
                      orderFilters[order.orderId] ||
                      (Array.isArray(order.subOrderStatus) &&
                        order.subOrderStatus[0]?.orderTypeName) ||
                      "Delivery"; // ultimate fallback

                    let matchedSubOrder = order.subOrderStatus?.find(
                      (s) => s.orderTypeName === activeFilter,
                    );

                    // Fallback: just use first if somehow not found (defensive)
                    if (!matchedSubOrder && order.subOrderStatus?.length > 0) {
                      matchedSubOrder = order.subOrderStatus[0];
                    }

                    // Map API orderTypeName to stepper type
                    const typeMap = {
                      Delivery: "Delivery",
                      "Self-Collection": "Collection", // assuming API uses "Self-Collection"
                      "In-Store": "DineIn",
                      DineIn: "DineIn", // in case it's sent as "DineIn"
                      Collection: "Collection",
                    };

                    const stepperType =
                      (matchedSubOrder &&
                        typeMap[matchedSubOrder.orderTypeName]) ||
                      "Delivery";

                    // 🔁 Map orderStatus to step ID based on stepperType
                    const statusToStepMap = {
                      Delivery: {
                        Pending: 1,
                        Preparing: 2,
                        Ready: 3,
                        "On the way to Restaurant": 3,
                        "Picked Up": 4,
                        "En-Route": 5,
                        Delivered: 6,
                      },
                      Collection: {
                        Pending: 1,
                        Preparing: 2,
                        Ready: 3,
                        Collected: 4,
                      },
                      DineIn: {
                        Pending: 1,
                        Preparing: 2,
                        Ready: 3,
                        Completed: 4,
                      },
                    };

                    const stepMap =
                      statusToStepMap[stepperType] || statusToStepMap.Delivery;
                    let currentStep;

                    if (props.type === "history") {
                      // Force last step only for Delivery and Collection
                      if (stepperType === "Delivery") {
                        currentStep = 6; // "Delivered"
                      } else if (stepperType === "Collection") {
                        currentStep = 4; // "Collected"
                      } else {
                        // Keep original behavior for DineIn (and any other type)
                        currentStep = matchedSubOrder
                          ? stepMap[matchedSubOrder.orderStatus] || 1
                          : 1;
                      }
                    } else {
                      // Normal behavior for pending/live orders
                      currentStep = matchedSubOrder
                        ? stepMap[matchedSubOrder.orderStatus] || 1
                        : 1;
                    }

                    return (
                      <>
                        <OrderStatusStepper
                          type={stepperType}
                          currentStep={currentStep}
                        />
                      </>
                    );
                  })()}

                  <p className="text-center text-secondary mb-0 fw-bold">
                    Your order is {order.orderStatus}.
                  </p>
                  <p className="text-center text-secondary">Please Wait.</p>
                  {/* ✅ OTP Button only for Delivery orders in pending state */}
                  {(() => {
                    const activeFilter =
                      orderFilters[order.orderId] ||
                      (Array.isArray(order.subOrderStatus) &&
                        order.subOrderStatus[0]?.orderTypeName) ||
                      "Delivery";

                    const matchedSubOrder = order.subOrderStatus?.find(
                      (s) => s.orderTypeName === activeFilter,
                    );

                    return (
                      <div className="text-center my-3">
                        {!openOtpModal &&
                          matchedSubOrder?.orderStatus !== "Delivered" &&
                          matchedSubOrder?.orderStatus === "En-Route" && (
                            <button
                              onClick={() => {
                                setOpenOtpModal(true);
                                setError("");
                              }}
                              style={{
                                padding: "14px 32px",
                                fontSize: 16,
                                fontWeight: 700,
                                color: "#fff",
                                background:
                                  "linear-gradient(135deg, #5a2e28, #371b17)",
                                border: "none",
                                borderRadius: 14,
                                cursor: "pointer",
                                boxShadow: "0 4px 16px rgba(55,27,23,0.3)",
                              }}
                            >
                              Show Delivery OTP
                            </button>
                          )}
                      </div>
                    );
                  })()}

                  {activeOrderType === "Delivery" && order.otp && (
                    <>
                      {openOtpModal && (
                        <OTPDisplay
                          otp={String(order.otp)}
                          onClose={() => setOpenOtpModal(false)}
                        />
                      )}
                    </>
                  )}

                  <div className="row">
                    <div className="col-md-6">
                      {(() => {
                        // Use isExpanded and displayedItems.
                        return (
                          <>
                            {displayedItems.map((item, idx) => {
                              const itemNumber = idx + 1;
                              const isRefund = item.type === "refund";
                              const isCanceledOrRefund =
                                isRefund ||
                                item.foodStatus === "Canceled" ||
                                item.foodStatus === "Refund";
                              const strikeThrough =
                                isCanceledOrRefund &&
                                order.orderStatus !== "Refund"
                                  ? "line-through"
                                  : "none";
                              const opacity =
                                isCanceledOrRefund &&
                                order.orderStatus !== "Refund"
                                  ? 0.6
                                  : 1;
                              const status = isRefund
                                ? "Refund"
                                : item.foodStatus;
                              const statusBg = isRefund
                                ? "rgba(231, 76, 60, .8)"
                                : status === "Pending"
                                  ? "rgba(243, 156, 18, .2)"
                                  : status === "Queue"
                                    ? "rgba(239, 83, 80, .2)"
                                    : status === "Preparing"
                                      ? "rgba(41, 128, 185, .2)"
                                      : status === "Ready"
                                        ? "rgba(39, 174, 96, .2)"
                                        : status === "Canceled"
                                          ? "rgba(231, 76, 60, .8)"
                                          : "";
                              const statusColor =
                                isRefund || status === "Canceled"
                                  ? "white"
                                  : status === "Pending"
                                    ? "rgb(243, 156, 18)"
                                    : status === "Queue"
                                      ? "rgb(239, 83, 80)"
                                      : status === "Preparing"
                                        ? "rgb(41, 128, 185)"
                                        : status === "Ready"
                                          ? "rgb(39, 174, 96)"
                                          : "";
                              const price = isRefund
                                ? getSubTotalOFComponentPrice(item)
                                : getSubTotalOFComponentPrice(item);

                              return (
                                <div
                                  key={`${item.type}-${idx}`}
                                  className="order-item mb-3 p-3"
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h6
                                      className="mb-0"
                                      style={{
                                        textDecoration: strikeThrough,
                                        opacity: opacity,
                                        fontFamily: "'DM Sans', sans-serif",
                                      }}
                                    >
                                      {itemNumber}) {item.foodItemName}{" "}
                                      <span className="text-muted">
                                        x{item.foodItemQuantity}
                                      </span>
                                      <span className="ms-2 text-muted">
                                        £
                                        {isRefund
                                          ? item.totalFoodItemPrice
                                          : item.basePrice *
                                            item.foodItemQuantity}
                                      </span>
                                    </h6>

                                    <div className="d-flex align-items-center">
                                      <span
                                        className="status-badge px-3 py-1 me-3"
                                        style={{
                                          background: statusBg,
                                          color: statusColor,
                                          borderRadius: "20px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {status}
                                      </span>

                                      <span
                                        // className="fw-bold"
                                        style={{
                                          minWidth: "49px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        £ {price}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Render Add-ons (common for both types) */}
                                  {(item.addOns || [])
                                    .filter((addOn) => addOn.addOnQuantity > 0)
                                    .map((addOn) => (
                                      <div
                                        key={addOn.addOnId}
                                        style={{ marginLeft: "18px" }}
                                      >
                                        <p
                                          style={{
                                            textDecoration: strikeThrough,
                                            opacity: opacity,
                                            fontFamily: "'DM Sans', sans-serif",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {addOn.addOnName}
                                          <span className="text-muted">
                                            {" "}
                                            x{addOn.addOnQuantity}
                                          </span>

                                          <span className="text-muted">
                                            {" "}
                                            £
                                            {addOn.addOnBasePrice *
                                              addOn.addOnQuantity}
                                          </span>
                                        </p>

                                        {/* Render Options only if quantity > 0 */}
                                        {addOn?.options
                                          ?.filter(
                                            (option) =>
                                              option.optionQuantity > 0,
                                          )
                                          ?.map((option) => (
                                            <div
                                              key={option.optionId}
                                              style={{ marginLeft: "1rem" }}
                                            >
                                              <h6
                                                style={{
                                                  textDecoration: strikeThrough,
                                                  opacity: opacity,
                                                }}
                                              >
                                                {option.optionName} x
                                                {option.optionQuantity}
                                                <span>
                                                  {" "}
                                                  £
                                                  {option.optionBasePrice *
                                                    option.optionQuantity}
                                                </span>
                                              </h6>

                                              {/* Render SubOptions only if quantity > 0 */}
                                              {option?.subOptions
                                                ?.filter(
                                                  (subOption) =>
                                                    subOption.subOptionQuantity >
                                                    0,
                                                )
                                                ?.map((subOption) => (
                                                  <div
                                                    key={subOption.subOptionId}
                                                    style={{
                                                      marginLeft: "2rem",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textDecoration:
                                                          strikeThrough,
                                                        opacity: opacity,
                                                      }}
                                                    >
                                                      {subOption.subOptionName}{" "}
                                                      x
                                                      {
                                                        subOption.subOptionQuantity
                                                      }
                                                      <span>
                                                        {" "}
                                                        £
                                                        {subOption.subOptionBasePrice *
                                                          subOption.subOptionQuantity}
                                                      </span>
                                                    </span>
                                                  </div>
                                                ))}
                                            </div>
                                          ))}
                                      </div>
                                    ))}
                                </div>
                              );
                            })}
                          </>
                        );
                      })()}
                    </div>

                    <div className="col-md-6">
                      <div
                        className="payment-breakdown p-3 shadow-sm rounded"
                        style={{}}
                      >
                        <h6 className="mb-3 payment-breakdown__title">
                          PAYMENT BREAKDOWN
                        </h6>
                        <ul
                          className="list-unstyled"
                          style={{
                            padding: 0,
                            margin: 0,
                            fontSize: "14px",
                            color: "#2E261F",
                          }}
                        >
                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>Sub Total</span>{" "}
                            <span>£{order?.subTotal?.toFixed(2)}</span>
                          </li>

                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>Total VAT</span>{" "}
                            <span>£{order?.totalVat?.toFixed(2)}</span>
                          </li>

                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>Total SD</span>{" "}
                            <span>£{order?.totalSD?.toFixed(2)}</span>
                          </li>

                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>
                              Total Service Charge Exc. VAT
                            </span>{" "}
                            <span>
                              £{order?.totalServiceChargeExcVat?.toFixed(2)}
                            </span>
                          </li>
                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>
                              Total Service Charge VAT (20%)
                            </span>{" "}
                            <span>
                              £{order?.totalServiceChargeVat?.toFixed(2)}
                            </span>
                          </li>
                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>Total Tips</span>{" "}
                            <span>£{order?.totalTips?.toFixed(2)}</span>
                          </li>
                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>
                              Delivery Fee Inc. VAT (20%)
                            </span>{" "}
                            <span>£{order?.deliveryFeeIncVat?.toFixed(2)}</span>
                          </li>
                          <li className="d-flex justify-content-between mb-2">
                            <span style={{ color: "#8c8073" }}>Credit</span>{" "}
                            <span>£{order?.credit?.toFixed(2)}</span>
                          </li>
                          {order?.totalRefundAmount > 0 && (
                            <li className="d-flex justify-content-between mb-2">
                              <span style={{ color: "#8c8073" }}>
                                Total Refunded amount
                              </span>{" "}
                              <span>
                                -£{order?.totalRefundAmount?.toFixed(2)}
                              </span>
                            </li>
                          )}
                        </ul>
                        <hr />
                        <div>
                          <h6 className="d-flex justify-content-between">
                            <div className="d-flex flex-column">
                              <h6
                                className="bold-text"
                                style={{ fontSize: "18px" }}
                              >
                                Total Price
                              </h6>
                              <span
                                style={{ color: "#8c8073", fontSize: "12px" }}
                              >
                                (VAT Inc.)
                              </span>
                            </div>
                            <h6 className="bold-text">
                              £{order.total?.toFixed(2)}
                            </h6>
                          </h6>
                        </div>
                      </div>

                      {/* Render delivery info directly from merged order data */}
                      {props.type === "pending" &&
                        activeOrderType === "Delivery" &&
                        order.deliveryPerson && (
                          <div className="space-y-4 sm:space-y-6">
                            {order.deliveryPerson.name && (
                              <DeliveryPersonCard
                                name={order.deliveryPerson.name || "Raj Kumar"}
                                photo="" // adjust if photo field exists
                                phone={
                                  order.deliveryPerson.primaryContactNumber ||
                                  ""
                                }
                                email={order.deliveryPerson.email || ""}
                                vehicleNumber="DL 01 AB 1234" // placeholder – update if available in API
                                rating={4.8} // placeholder – update if available
                                deliveriesCompleted={342} // placeholder – update if available
                              />
                            )}

                            <DeliveryAddress
                              address={
                                order.deliveryPerson.deliveryAddressDetails ||
                                "Address not provided"
                              }
                              deliveryNote={
                                order.deliveryPerson.deliveryNote || "N/A"
                              }
                              estimatedTime="15–20 mins" // placeholder – update if available
                            />
                          </div>
                        )}
                    </div>
                  </div>

                  {totalCount > 3 && (
                    <div className="text-center">
                      <button
                        className="see-more-btn"
                        onClick={() => handleToggle(index)}
                      >
                        {isExpanded ? "See Less" : "See More"}
                        {isExpanded ? (
                          <FaAngleDoubleUp />
                        ) : (
                          <FaAngleDoubleDown />
                        )}
                      </button>
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}

        <ReceiptModal
          open={open?.isOpen}
          handleClose={handleClose}
          timeLineData={open.timeLine}
        />
      </div>
    </>
  );
};

export default PendingOrderAccordion;
